export enum RegionId {
  None = 0,
  Norway = 1,
  Sweden = 2,
  Denmark = 3,
  Finland = 4,
  Germany = 5,
  Spain = 6,
}

export const RegionIdToCountryCode = (region: RegionId) => {
  switch (region) {
    case RegionId.Norway:
      return "no";
    case RegionId.Sweden:
      return "se";
    case RegionId.Denmark:
      return "dk";
    case RegionId.Finland:
      return "fi";
    case RegionId.Germany:
      return "de";
    case RegionId.Spain:
      return "es";
  }
  throw Error("Region not supported");
};

export const REGIONS_USING_EURO = [RegionId.Germany, RegionId.Spain, RegionId.Finland];

export const regionToPhonePrefix = (region: RegionId): string => {
  switch (region) {
    case RegionId.Norway:
      return "+47";
    case RegionId.Sweden:
      return "+46 (0)";
    case RegionId.Denmark:
      return "+45";
    case RegionId.Finland:
      return "+358 (0)";
    case RegionId.Germany:
      return "+49";
    case RegionId.Spain:
      return "+34";
    default:
      return "+47"; // Default to Norway
  }
};
